import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import { gridQueryKey } from './useGrid'

import type { Grid, GridVersion, WorkspaceId } from 'honeygrid-types'

export const gridVersionsQueryKey = (workspaceId: WorkspaceId, gridId: Grid['uuid']) =>
	[...gridQueryKey(workspaceId, gridId), 'versions'] as const

interface GridVersionsParams {
	workspaceId?: string
	gridId: Grid['uuid']
	enabled?: boolean
}

export const useGridVersions = ({
	workspaceId = '',
	gridId,
	enabled = true,
}: GridVersionsParams) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<GridVersion[]>({
		queryKey: gridVersionsQueryKey(workspaceId, gridId),
		queryFn: (): Promise<GridVersion[]> =>
			authFetch(`workspaces/${workspaceId}/grids/${gridId}/versions`),
		enabled: enabled && !!workspaceId && !!gridId,
	})
}
